import React from 'react';
import { Button, Select, Space, Tooltip } from 'antd';
import { PlusOutlined, EditOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Project } from '../../types/project';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/userSlice';

const Container = styled.div`
  margin-bottom: 24px;
`;

const ProjectSelect = styled(Select)`
  width: 100%;
  margin-bottom: 12px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;

  .ant-btn {
    flex: 1;
    padding: 4px 0;
    height: 32px;
    min-width: 0;
    
    .anticon {
      font-size: 14px;
      margin-right: 4px;
    }
  }
`;

interface ProjectSelectorProps {
  projects: Project[];
  currentProject: Project | null;
  onProjectSelect: (project: Project) => void;
  onCreateClick: () => void;
  onEditClick?: () => void;
}

const ProjectSelector: React.FC<ProjectSelectorProps> = ({
  projects,
  currentProject,
  onProjectSelect,
  onCreateClick,
  onEditClick
}) => {
  const user = useSelector(selectUser);

  return (
    <Container>
      <ProjectSelect
        value={currentProject?.id}
        onChange={(value) => {
          const project = projects.find(p => p.id === value);
          if (project) {
            onProjectSelect(project);
          }
        }}
        placeholder="选择项目"
      >
        {projects.map(project => (
          <Select.Option key={project.id} value={project.id}>
            {project.projectName}
          </Select.Option>
        ))}
      </ProjectSelect>
      {user && (
        <ButtonGroup>
          <Tooltip title="创建新项目">
            <Button 
              type="default"
              icon={<PlusOutlined />}
              onClick={onCreateClick}
            >
              新建
            </Button>
          </Tooltip>
          {currentProject && (
            <Tooltip title="编辑项目信息">
              <Button
                type="default"
                icon={<EditOutlined />}
                onClick={onEditClick}
              >
                编辑
              </Button>
            </Tooltip>
          )}
        </ButtonGroup>
      )}
    </Container>
  );
};

export default ProjectSelector; 